import { api } from "./base";
/**
 * «Песня в стиле референса»: юзер прикладывает аудио или видео, бэкенд вырезает
 * отрезок ≤ 60 с, ИИ описывает его музыкальный стиль, а описание уходит в
 * генерацию (`style_reference_id` в `generateMusic`). Мелодия не копируется.
 *
 * Базовый путь: /api/v1/public/songs/style-reference. Работает на сайте и в
 * миниапах TG/MAX. Заголовки авторизации (Bearer / initData / X-Session-Id)
 * навешивает axios-интерсептор `api` (как в voice.ts).
 */
const BASE = "/api/v1/public/songs/style-reference";
export const getStyleReferenceAvailability = async () => {
    const res = await api.get(`${BASE}/availability`);
    return res.data;
};
// Multipart: снимаем Content-Type, чтобы браузер сам выставил boundary.
const MULTIPART_HEADERS = { "Content-Type": undefined };
/**
 * Загрузить референс и получить описание стиля. `onUploadProgress` — доля
 * отправленного файла 0..1 (после 100% сервер ещё анализирует трек).
 */
export const analyzeStyleReference = async (file, onUploadProgress) => {
    const formData = new FormData();
    formData.append("file", file);
    const res = await api.post(BASE, formData, {
        headers: MULTIPART_HEADERS,
        // Анализ (ffmpeg + ИИ) может занять до минуты-двух — не обрываем раньше.
        timeout: 180000,
        onUploadProgress: (e) => {
            if (onUploadProgress && e.total)
                onUploadProgress(e.loaded / e.total);
        },
    });
    return res.data;
};
